import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import GeneralUtilsHelper from "@/utils/generalUtils";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";

var VipBotton =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipBotton, _Vue);

  function VipBotton() {
    _classCallCheck(this, VipBotton);

    return _possibleConstructorReturn(this, _getPrototypeOf(VipBotton).apply(this, arguments));
  }

  _createClass(VipBotton, [{
    key: "buyVip",
    value: function () {
      var _buyVip = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit("buyVip");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buyVip() {
        return _buyVip.apply(this, arguments);
      }

      return buyVip;
    }()
  }, {
    key: "linearGradientColor",
    get: function get() {
      return this.isTry ? 'linear-gradient(82.58deg, #5d35fe -4.68%, #fb2a8e 104.87%)' : '#603BF3';
    }
  }, {
    key: "isRenew",
    get: function get() {
      return GeneralUtilsHelper.isRenew();
    }
  }]);

  return VipBotton;
}(Vue);

tslib_1.__decorate([Prop()], VipBotton.prototype, "isTry", void 0);

VipBotton = tslib_1.__decorate([Component({
  components: {
    loadingAnimaton: loadingAnimaton
  }
})], VipBotton);
export default VipBotton;